import * as amplitude from '@amplitude/unified'

const API_KEY = process.env.GATSBY_AMPLITUDE_API_KEY
const isBrowser = typeof window !== 'undefined'

export const initAmplitude = () => {
  if (!isBrowser || !API_KEY) {
    console.warn('[Amplitude] GATSBY_AMPLITUDE_API_KEY is not set. Analytics disabled.')
    return false
  }

  amplitude.initAll(API_KEY, {
    serverZone: 'EU',
    analytics: {
      autocapture: true
    }
  })

  return true
}

export const trackPageView = (path) => {
  if (!isBrowser || !API_KEY) return
  amplitude.track('Page Viewed', {path})
}

export const trackEvent = (eventName, eventProperties = {}) => {
  if (!isBrowser || !API_KEY) return
  amplitude.track(eventName, eventProperties)
}

export const identifyUser = (userId) => {
  if (!isBrowser || !API_KEY) return
  amplitude.setUserId(userId)
}
